import { useMemo } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { Outlet } from 'react-router-dom'
import globalStore from 'store'
import Header from 'components/public/Header'
import Footer from 'ui/src/components/Footer'
import { ContainerBackground } from 'ui/src/components/Container'
import AppHeader from '../AppHeader'
import AppHeaderV2 from 'containers/App/AppHeaderV2'
import Box from 'ui/src/components/Box'

const AppRegisterLayout = () => {
  const user = globalStore(state => state.user)
  const isHighLevelUser = globalStore(state => state.isHighLevelUser)
  const register = globalStore(state => state.register)
  const logout = globalStore(state => state.logout)
  const avatarChanged = globalStore(state => state.avatarChanged)
  const getAvatar = globalStore(state => state.getAvatar)
  const avatar = globalStore(state => state.avatar)
  const setAvatar = globalStore(state => state.setAvatar)
  const flags = useFlags()
  const hasHighLevelPrivileges = isHighLevelUser()

  const headerPicker = useMemo(() => {
    if (flags.dashboardV2) {
      if (user) {
        return (
          <AppHeaderV2
            showLogo={true}
            user={user}
            hasHighLevelPrivileges={hasHighLevelPrivileges}
            register={register}
            logout={logout}
            avatarChanged={avatarChanged}
            getAvatar={getAvatar}
            avatar={avatar}
            setAvatar={setAvatar}
            referrals={true}
          />
        )
      }
      return <AppHeaderV2 showLogo={true} />
    }
    if (user) {
      return <AppHeader />
    }
    return <Header />
  }, [
    flags.dashboardV2,
    user,
    hasHighLevelPrivileges,
    register,
    logout,
    avatarChanged,
    getAvatar,
    avatar,
    setAvatar,
  ])

  const marginTopPicker = useMemo(() => {
    if (flags.dashboardV2) return '0rem'
    if (user) return '0.5rem'
    return '6.313rem'
  }, [flags.dashboardV2, user])

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        minHeight: '100vh',
        height: '100%',
      }}
    >
      {headerPicker}
      <ContainerBackground
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          minHeight: 'fit-content',
          px: 0,
          py: 4,
          mt: marginTopPicker,
          flex: 1,
        }}
      >
        <Outlet />
      </ContainerBackground>
      <Footer />
    </Box>
  )
}

export default AppRegisterLayout
